/*============================================================================
               # Site Nav Mobile
==============================================================================*/

$(".mobile-nav--open, .mobile-nav__off-click").on("click", function () {
    var mainBody = $(".main-body-content");
    var headerContent = $(".flex-header-content");
    var mobileNavWrapper = $(".mobile-nav-wrapper");
    var mobileNavOffClick = $(".mobile-nav__off-click");
    var mobileNavDropdown = $(".mobile-nav__dropdown");

    mobileNavDropdown.slideUp();
    mainBody.toggleClass("main-body-content__close");
    headerContent.toggleClass("flex-header-content__close");
    mobileNavWrapper.toggleClass("mobile-nav__open");
    mobileNavOffClick.toggleClass("mobile-nav__off-click--active");

    if (mobileNavWrapper.hasClass("mobile-nav__open")) {
        mobileNavWrapper.css("display", "block");
        mobileNavOffClick.fadeTo("slow", 1);
    } else {
        mobileNavOffClick.fadeTo("slow", 0);
        setTimeout(function () {
            mobileNavWrapper.css("display", "none");
        }, 600);
    }
});

$(".mobile-nav-parent__dropdown").on("click", function () {
    var childDropDown = $(this).attr("data-target");
    var childMenu = $("ul[data-parent='" + childDropDown + "']");

    $(".mobile-nav__dropdown").slideUp();

    if (childMenu[0].style.display !== "block") {
        childMenu.slideDown();
    }
});

$(".mobile-nav--height").on("click", function () {
    var topHeight = $(window).scrollTop();
    var navWrapper = $(".mobile-nav-wrapper");
    navWrapper.css("position", "fixed");
    navWrapper.css("top", topHeight + "px");
});

$(".site-nav--has-dropdown").find("button").on("click", function () {
    var childMenu = $(this).attr("aria-controls");

    $(".sub-navigation").each(function () {
        if ($(this).is(":visible") && !$(this).is($("#" + childMenu))) {
            $(this).slideToggle(300);
        }
    });

    $("#" + childMenu).slideToggle();
});

$("#siteNavAccountMenu").on("click", function () {
    $(".site-header__account-menu").toggleClass("d-md-block");
});

/*============================================================================
               # Global JS Functions
==============================================================================*/



// setting this in the calling theme pages instead for testing
// var userId = '' || null;

// global variable representing the current page a person has landed on
const shopifyLandingPageUrl = window.location.href.split("?")[0];

var urlParams = function (searchString) {
    var returnObject = {};
    var search = window.location.search.replace('?', '').split('&');
    for (var i = 0; i < search.length; i += 1) {
        var term = search[i].split('=');
        returnObject[term[0]] = term[1];
    }

    return returnObject[searchString];
}

// Global Cookie Getter/Setter functions
var setCookie = function (name, value, days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "; expires=" + date.toGMTString();
    if (days === 0) {
      expires = "";
    }
    document.cookie = name + "=" + value + expires + ";path=/";
  }

var setCookieMinutes = function (name, value, minutes) {
let date = new Date();
date.setTime(date.getTime() + (minutes * 60 * 1000));
let expires = "; expires=" + date.toGMTString();
if (minutes === 0) {
    expires = "";
}
document.cookie = name + "=" + value + expires + ";path=/";
}
  
  
var getCookie = function (cookieName) {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
        let [key,value] = el.split('=');
        cookie[key.trim()] = value;
    })
    return cookie[cookieName];
}

// detect if the page has been reloaded to avoid double counting for certain tracking
const pageReloaded = () => {

	const [navigation] = performance.getEntriesByType('navigation');
	if (navigation.type === 'reload') {
	    return true;
	} else {
	    return false;
	}
}

// Get IP address from cookie or set it if blank
  const getIpAddress = () => {
    let ipCookie = getCookie('ipAddress');
    if (ipCookie != null) {
        return ipCookie;
    } else {
        setIpAddress();
        return '';
    }
}

// Get IP Address from ipify and then set the cookie after it returns
const setIpAddress = async () => {
    await $.getJSON("https://api.ipify.org?format=json", function(data) {
        const dataIp = await = data.ip;
        // Set cookie for 1 day
        setCookie('ipAddress', dataIp, 1);
    });

    return dataIp;
}

// Our internal IP address lists for use to avoid tracking from internal users
const zrcIpList = ["12.207.39.162","72.213.245.216","64.58.161.130","12.50.26.66","4.59.48.126","98.173.6.210"];
const zreIpList = ['62.214.150.146','104.151.60.116','109.90.19.186','109.90.19.187','109.90.19.188','109.90.19.189','109.90.19.190','62.91.165.36'];

const internalIpList = [
    ...zrcIpList,
    ...zreIpList,
]

// Allow tracking based on internal IP address check and allow stage site tracking
const allowTracking = () => {
    const ipAddressCheck = getIpAddress();

    // 

    const allowTrackCookie = getCookie('allowTrack');
    if (allowTrackCookie) {
      return true;
    }

    if (document.location.href.indexOf('stage') > -1) return true;
    const ipMatchArr = internalIpList.filter(intIp => {
    if (ipAddressCheck == intIp) return true;
    })

    console.log('ipMatchArr', ipMatchArr);
    if (ipMatchArr.length) {
      return false;
    }

    return true;
}

const trackingAllowed = allowTracking();
console.log('trackingAllowed', trackingAllowed);

// Global functions to generate a title-case string from a URL

const stringToTitleCase = (str) => {
    return str.replace(
      /\w\S*/g,
      function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }
  
  const titleFromHandle = (url) => {
      const handleArr = url.split('/');
      const handle = handleArr[handleArr.length-1].replace(/-/g, " ");
      console.log('handle', handle);
      return stringToTitleCase(handle);
  }

// MIXPANEL code migrated to this, more global script file
// get search customer either logged in or local storage
var uid = function(){
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
}

var getSearchCustomer = function() {
    var guestSearchCustomer = localStorage.getItem('searchCustomer') || uid();
    localStorage.setItem('searchCustomer', guestSearchCustomer);
    return guestSearchCustomer
}

// using global variable userId from site-header.liquid
var searchCustomer = userId || getSearchCustomer();
var isRegistered = userId ? true : false;

// using sessionStorage variable from site-theme.liquid
var website = sessionStorage.getItem("georedirectorsite");

function cleanPageTitle(pageTitle){
    return pageTitle.split(' | ')[0].trim();
}

// Using page title of document
var pageTitle = document.title.indexOf('|') >= 0 ? cleanPageTitle(document.title) : document.title; 

// MixPanel load and functions

(function(f,b){if(!b.__SV){var e,g,i,h;window.mixpanel=b;b._i=[];b.init=function(e,f,c){function g(a,d){var b=d.split(".");2==b.length&&(a=a[b[0]],d=b[1]);a[d]=function(){a.push([d].concat(Array.prototype.slice.call(arguments,0)))}}var a=b;"undefined"!==typeof c?a=b[c]=[]:c="mixpanel";a.people=a.people||[];a.toString=function(a){var d="mixpanel";"mixpanel"!==c&&(d+="."+c);a||(d+=" (stub)");return d};a.people.toString=function(){return a.toString(1)+".people (stub)"};i="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
for(h=0;h<i.length;h++)g(a,i[h]);var j="set set_once union unset remove delete".split(" ");a.get_group=function(){function b(c){d[c]=function(){call2_args=arguments;call2=[c].concat(Array.prototype.slice.call(call2_args,0));a.push([e,call2])}}for(var d={},e=["get_group"].concat(Array.prototype.slice.call(arguments,0)),c=0;c<j.length;c++)b(j[c]);return d};b._i.push([e,f,c])};b.__SV=1.2;e=f.createElement("script");e.type="text/javascript";e.async=!0;e.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"file:"===f.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";g=f.getElementsByTagName("script")[0];g.parentNode.insertBefore(e,g)}})(document,window.mixpanel||[]);

const mixPanelIdentify = () => {
    const mixpanelUserId = searchCustomer;

    // Get UserId based on local storage/cookies or generated unique id
    mixpanel.identify(mixpanelUserId);
}

const mixPanelInit = () => {
    mixpanel.init('41a444cdfb0de51bd98499e8dfe46fdd', {
    debug: true,
    track_pageview: true,
    persistence: 'localStorage'
    });

    mixPanelIdentify();
}

const mixPanelTrack = (trackType, data) => {

  const ipAddress = getIpAddress();

  const googleAdTypeStr = getGoogleAdType();

  let googleAdType = googleAdTypeStr || "none";
  let googleAd = googleAdTypeStr ? true : false;

  let utmData = getUTMData();
  const {
      source,
      medium,
      campaign,
      content,
      term,
      utmType,
  } = utmData;

  const trackData = {
      ...data,
      ipAddress,
      isRegistered,
      website,
      pageTitle,
      googleAd,
      googleAdType,
      source,
      medium,
      campaign,
      content,
      term,
      utmType,
  }

  // using global variable trackingAllowed from site-header.liquid
  // Only fire tracking event if allowed based on internal IP restrictions
  if (trackingAllowed) {
      mixpanel.track(trackType, trackData);

      // Add in targeted GA4 events here
      let ga4TrkEvent = '';
      let click = data.click || '';
      let form_name = data.description || '';

    // Base data we'll send to GA4, augment as needed.
    // include passed tracking "data" here, any non-specified parameters in Tag Manager are ignored
    let ga4TrkData = {
      ...data,
      ipAddress,
      source,
      medium,
      campaign,
      content,
      term,
      utmType,
      }

    // if this is a form, then add in form_name
    if (form_name !== '') {
      ga4TrkData = {
        ...ga4TrkData,
        form_name,
      }
    }

    // WUFOO FORM SUBMISSIONS
    if (trackType === "WuFooFormSubmission") {
      // click for free sample forms should always be freeSample
      // ensure this is the case so these work as expected
      if (click === 'freeSample') {
        ga4TrkEvent = 'free_sample_form_submit'
      }

      if (click === 'contactUs') {
        ga4TrkEvent = 'contact_form_submit'
      }

      if (click === 'automationForm') {
        ga4TrkEvent = 'automation_form_submit'
      }
    }

    // SERVICES FORM SUBMISSIONS
    if (trackType === "ServicesFormSubmission") {
        ga4TrkEvent = 'service_form_submit'
    }

    // SERVICES INQUIRY FORM SUBMISSIONS
    if (trackType === "ServicesInquiryFormSubmission") {
      ga4TrkEvent = 'service_inquiry_form_submit'
    }

    // LEARNING CENTER TALK TO AN EXPORT FORM SUBMISSIONS
    if (trackType === "TalkToExpertFormSubmission") {
      ga4TrkEvent = 'talk_to_expert_form_submit'
    }

    // CONTACT FORM SUBMISSIONS
    if (trackType === "ContactFormSubmission") {
      ga4TrkEvent = 'contact_form_submit'
    }

    // we have an event to fire, fire it now
    if (ga4TrkEvent != "") {
      trackGA4Event(ga4TrkEvent, ga4TrkData);
      console.log('tracking GA4 Event', ga4TrkEvent, ga4TrkData);
    }

  }
}

 // using global variable trackingAllowed from site-header.liquid
 // Only fire mixPanelInit if allowed based on internal IP restrictions
 if (trackingAllowed) {
     mixPanelInit();
 }


// WUFOO Forms

const getUTMData = () => {

    // get all possible stored utm objects
    const utmAdDirect = localStorage.getItem('clickTrackUTMDirect');
    const utmAdAssisted = localStorage.getItem('clickTrackUTMAssisted');
  
    let utmType = null;
    // test each one in order of priority, ending with the default "blank" object
  
    let utmJson = `{}`;

    if (utmAdDirect) {
        utmType = "direct";
        utmJson = utmAdDirect;
    } else if (utmAdAssisted) {
        utmType = "assisted";
        utmJson = utmAdAssisted;
    }

    const utmData = JSON.parse(utmJson);
    const {
        source = null,
        medium = null,
        campaign = null,
        content = null,
        term = null,
    } = utmData;

    let utmResponse = {
        source,
        medium,
        campaign,
        content,
        term,
        utmType 
    }
  
    return utmResponse;
  }
  

const getGoogleAdType = () => {

    // get all possible stored googleAd objects
    const googleAdDirect = localStorage.getItem('clickTrackGCLIDDirect');
    const googleAdAssisted = localStorage.getItem('clickTrackGCLIDAssisted');
  
    let googleAdType = null;
    // test each one in order of priority, ending with the default "blank" object
  
    if (googleAdDirect) {
      googleAdType = "direct";
    } else if (googleAdAssisted) {
      googleAdType = "assisted";
    }
  
    return googleAdType;
  }
  
const getWuFooExpiration = () => {

    // set dates for expiration
    let expires = new Date();
    // add days (1) - DEFAULT
    expires.setDate(expires.getDate() + 1);
    console.log('WUFOO Default expires', expires);

    // try to get longest expiration we have for Google Ad tracking
    const googleAdAssisted = localStorage.getItem('clickTrackGCLIDAssisted');
    if (googleAdAssisted) {

        // if we have GCLID set wufoo expiration to match this
        const gaData = JSON.parse(googleAdAssisted);
        expires = gaData.expires;
        console.log('WUFOO expires using GCLID expires', expires);
    }

    return expires;
}

const getLPCookie = () => {
    const lpUrl = getCookie('landingPageUrl');
    return lpUrl;
}

let lpCookieSet = false;
const setLPCookie = () => {    
    const lpUrl = getLPCookie();
    if (shopifyLandingPageUrl != lpUrl) {
        // set a 2 minute cookie, helps to avoid double firing of js functions on reload
        // only set if one does not exist or the same as current page
        setCookieMinutes('landingPageUrl', shopifyLandingPageUrl, 2);
        lpCookieSet = true;
    }
}

// learning center contact form submit handler

const learningCenterContactSubmitHandler = () => {
  // add any form validation necessary here when ready
  // make sure to only place this mixPanelTrack event into the spot that is after any validation occurs

  // contact_header is set in the form component and should be available here
  mixPanelTrack('TalkToExpertFormSubmission', { description: contact_header });
}

const trackGA4Event = (event, data) => {
  // Grab event and any other special data
  console.log('GA4 tracking event ' + event + ' with data ', data);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
  'event': event,
  data: data,
   });
}
  
// WUFOO Forms

const trackWuFooFormView = (description, click, pageType, locationInfo) => {

    const landingPageUrl = window.location.href.split("?")[0];

    const type = pageType || 'landingPage';
    const location = locationInfo || 'page';
    const googleAdTypeStr = getGoogleAdType();

    let googleAdType = googleAdTypeStr || "none";
    let googleAd = googleAdTypeStr ? true : false;

    let utmData = getUTMData();
    const {
        source,
        medium,
        campaign,
        content,
        term,
        utmType,
    } = utmData;

    // set date/time for expiration
    const expires = getWuFooExpiration();

    const wufooFormView = {
    description,
    click,
    type,
    location,
    expires,
    googleAd,
    googleAdType,
    source,
    medium,
    campaign,
    content,
    term,
    utmType,
    landingPage: landingPageUrl
    }

    console.log('wufooFormView data', wufooFormView);

    // save to local storage
    localStorage.setItem('wufooForm', JSON.stringify(wufooFormView));

    mixPanelTrack(
    'WuFooFormView', {
        description,
        click,
        type,
        location,
        googleAd,
        googleAdType,
        source,
        medium,
        campaign,
        content,
        term,
        utmType,
        landingPage: landingPageUrl
    });
}

const trackWuFooFormSubmission = () => {

    if (!lpCookieSet && forceWuFooSubmissionTrack === false) {
        console.log('lp ck not just set')
        // if we did not just reset the lp tracking cookie, then return false
        return false;
    }

    const wufooFormInfo = localStorage.getItem('wufooForm');
    console.log('wufooFormInfo', wufooFormInfo);
    if (wufooFormInfo) {
        console.log('wufooFormInfo', wufooFormInfo);
        wufooFormData = JSON.parse(wufooFormInfo);
        const {
            description,
            click,
            type,
            location,
            googleAd,
            googleAdType,
            landingPage,
            source = null,
            medium = null,
            campaign = null,
            content = null,
            term = null,
            utmType = null
        } = wufooFormData;

        console.log('wufooFormData', wufooFormData);

        mixPanelTrack(
        'WuFooFormSubmission', {
            description,
            click,
            type,
            location,
            googleAd,
            googleAdType,
            source,
            medium,
            campaign,
            content,
            term,
            utmType,
            landingPage
        });

        console.log('WuFooFormSubmission data', { description, click, type, location, googleAd, googleAdType, landingPage });
    }

}

const wufooFormSubmissionModal = () => {

    let wuFooModalTitle = $('#global-modal-center-title')
    wuFooModalTitle.addClass("text-green");
    wuFooModalTitle.text('Thank You!')

    let wuFooModalContent = $('#global-modal-center-content');
    wuFooModalContent.html(`Thank you for your inquiry.<br />We will be in touch with you shortly.`);

    let wuFooModalButton = $('#global-modal-center-btn');

    wuFooModalButton.click();

}

// Function to check if there are any checkboxes with name="requested-services" and get their labels if checked

let servicesFormTrackingFired = false;
const getRequestedServices = () => {
  // Get all checkboxes with name="requested-services"
  const checkboxes = document.querySelectorAll('input[name="requested-services"]');
  let hasRequestedServices = false;
  const selectedServices = [];

  checkboxes.forEach(checkbox => {
    if (checkbox.checked) {
      hasRequestedServices = true;
      const label = document.querySelector(`label[for="${checkbox.id}"]`);
      if (label) {
        selectedServices.push(label.textContent);
      }
    }
  });

  if (hasRequestedServices) {
    console.log('Selected Services:', selectedServices);
    return selectedServices.join(',');
  } else {
    console.log('No services selected.');
    return "";
  }
}

const handleUserLoginRegisterTracking = () => {

  // if they reload, then do not track again
  if (pageReloaded() === true) {
    return false;
  }

  const userLoginRegisterCookie = getCookie('userLoginRegister');
  if (!userLoginRegisterCookie) return null;

  // if its an event we're tracking, then track it here
  trackGA4Event(userLoginRegisterCookie, { user_id: userId });
  console.log('handleUserLoginRegisterTracking tracking this for userId ', userLoginRegisterCookie, userId)

  return true;
}

const loginRegisterInit = (type) => {
  // set the cookie to last 20 seconds
  setCookieMinutes('userLoginRegister', type, 0.3);
}

const checkServicesForm = () => {

  const landingPageUrl = document.location.href;

  let isServicesForm = false;
  const knownServicesFormHandles = [
    'pages/microbiome-service-submission-form',
    'pages/services-submission'
  ]

  for (let i=0;i<knownServicesFormHandles.length;i++) {
    const thisHandle = knownServicesFormHandles[i];
    if (landingPageUrl.indexOf(thisHandle) > -1) {
      isServicesForm = true;
    }
  }

  return isServicesForm;
}
 
const getServicesFormData = () => {

  let description = "General Services";
  let services_requested = "";
  const landingPageUrl = document.location.href;
  if (landingPageUrl.indexOf('microbiome-service-submission') > -1) {
    description = "Microbiome Services";
    services_requested = "Microbiome Services"
  } else {
    services_requested = getRequestedServices();
  }

  const servicesFormData = {
    description,
    services_requested,
  }

  console.log('servicesFormData', servicesFormData);
  return servicesFormData;
}
 
 // Function to be called when the element becomes visible
 const trackServicesFormSubmission = () => {
  const servicesFormData = getServicesFormData();
  
  console.log('FIRE MIXPANEL ServicesFormSubmission event');
  
  if (servicesFormTrackingFired === false) {
    mixPanelTrack('ServicesFormSubmission', servicesFormData);
    console.log('servicesFormData', servicesFormData);
    servicesFormTrackingFired = true;      
  }
 
 }
 
 let isServicesInquiryForm = false;

 const observeServicesSubmission = () => {

  if (isServicesInquiryForm === true) {
    return false;
  }

  console.log('FIRE MIXPANEL ServicesFormView event');

  const servicesFormData = getServicesFormData();
  mixPanelTrack('ServicesFormView', servicesFormData);

  // Find the correct h2 element with the exact text "Thank you!"
  const targetElement = Array.from(document.querySelectorAll('h2.text-center'))
    .find(h2 => h2.textContent.trim() === 'Thank you!');

  if (!targetElement) {
    console.error('Target element with "Thank you!" not found.');
    return;  // Exit if the element is not found
  }

  // Create an Intersection Observer
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        trackServicesFormSubmission();
        observer.disconnect();  // Stop observing after tracking the event
      }
    });
  }, { threshold: 0.1 });  // You can adjust the threshold value as needed

  // Observe the specific "Thank you!" h2 element
  observer.observe(targetElement);
};
   
 if (checkServicesForm() === true) {
  // observer fires too early to detect <h2> Thank you tag, wait 3 seconds
  setTimeout(function() {
    observeServicesSubmission();
   }, 3000);
  }


// if reg/login cookie present, track it
handleUserLoginRegisterTracking();
 
// return the object
const checkExpiredWufoo = () => {
    const wufooFormLS = localStorage.getItem('wufooForm');
  
    if (wufooFormLS) {

    const wufooFormLSData = JSON.parse(wufooFormLS);
  
      // set comparison dates
      const dateNow = new Date();
      const dateExpires = new Date(wufooFormLSData.expires);
  
      // We have an old entry, delete it
      if (dateNow >= dateExpires) {
        localStorage.removeItem('wufooForm');
      }
    }
  }
  
  // check any older ones for expiration
  checkExpiredWufoo();

  // set landingPage cookie (if not already set to this page)
  setLPCookie();

  // TESTING ADDITION OF ALL GCLID AND UTM STORAGE ETC HERE...

  // If a GCLID or UTM is present as a URL parameter, this code will run to
// set each of the clickTrackObject (gclid and utm) into localStorage.  This file is placed in /snippets/site-header.liquid
// and on /layout/marketing-theme.liquid. Essentially, all pages except for the checkout page.
// This localStorage object will be parsed by /assets/orderSuccessFirstTime.js.liquid
// and will be POSTed to NetSuite when the Order Status page is seen for the first time after
// completing an order. 

const landingPageUrl = window.location.href.split("?")[0];

let gclid = getParam("gclid");
let cn = getParam("cn");

// What does agn do? Where is it used?
let agn = getParam("agn");

let utm = window.location.href.indexOf("utm");

// function to create a unique id (for non-customers)
var uid = function(){
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
}

// Get the customer id if known, or ls version of uid or create new uid and store it
var getGoogleAdCustomer = function() {
  var googleAdCustId = localStorage.getItem('searchCustomer') || uid();
  localStorage.setItem('searchCustomer', googleAdCustId);
  return googleAdCustId
}

// using global variable userId from site-header.liquid
var googleAdCustomer = userId || getGoogleAdCustomer();
var isRegistered = userId ? true : false;

const postGoogleAdDataToApi = (eventName, eventData) => {

  const unixTimestamp = Math.floor(new Date() / 1000);

  // adding distinct_id and isRegistered to simulate browser data for mixpanel
  const enhancedEventData = {
    ...eventData,
    distinct_id: googleAdCustomer,
    isRegistered: isRegistered,
    time: unixTimestamp
  }

  const googleAdEventData = {
    eventName,
    eventData: enhancedEventData,
  }

  const settings = {
    type: 'POST',
    url: "https://service-api-dev.zymoresearch.com/googleAds/postGoogleAdsMixpanelData",
    data: JSON.stringify(googleAdEventData),
    dataType: 'json',
    success: function (res) {
        console.log('post google res', res);
    },
    error: function (e) {
      console.log('post google error', e)
    }
  };

  $.ajax(settings).done(function (response) {
    console.log('response', response);
  });

  // rerun a second time to avoid any 504 gateway timeouts on API Gateway
  // it will not create duplicates as database is checked for them
  setTimeout(function() {
    $.ajax(settings).done(function (response) {
      console.log('response', response);
    });
  }, 2000);

}

const trackGoogleClick = () => {

    // if a gclid is present on this landing page, track a GoogleAdClick
    if(gclid) {
      // post data for mix panel, but store in mongo after supermetrics fills in ad data
      postGoogleAdDataToApi("GoogleAdClick", {
        gclid,
        landingPage: landingPageUrl,
      })
    }

  return {
    gclid,
    landingPageUrl,
  };
}

// services inquiry form

const serviceTypeLookup = {
1: {
  "service_type": "Microbiomics"	
  },
2: {
  "service_type": "Microbiomics : 16S/ITS/18S Sequencing"	
  },
3: {
  "service_type": "Microbiomics : Metagenomic Shotgun Sequencing"
  },
4: {
  "service_type": "Epigenetics"	
  },
5: {
  "service_type": "Epigenetics : Methyl MaxiSeq (WGBS)"	
  },
6: {
  "service_type": "Epigenetics : Methyl MiniSeq"	
  },
7: {
  "service_type": "Epigenetics : RRBS"	
  },
8: {
  "service_type": "Epigenetics : Targeted Bisulfite Sequencing"
  },
9: {
  "service_type": "Epigenetics : ChIP-Seq"	
  },
10: {
  "service_type": "Gene Expression"	
  },
11: {
  "service_type": "Gene Expression : RNA-Seq"	
  },
12: {
  "service_type": "Epigenetic Aging"	
  },
13: {
  "service_type": "Epigenetic Aging : DNAge"
  },
14: {
  "service_type": "Environmental Surveillance"	
  },
15: {
  "service_type": "Environmental Surveillance : COVID-19 Variant Sequencing"
  },
16: {
  "service_type": "Environmental Surveillance : SARS-CoV-2 Wastewater Monitoring"	
  },
17: {
  "service_type": "Other"	
  },
18: {
  "service_type": "Other : Nucleic Acid Purification"	
  },
19: {
"service_type": "Other : Bioinformatics Analysis"	
  },
20: {
  "service_type": "Microbiomics : Metatranscriptomics"	
  },
21: {
  "service_type": "Other : Other Service not listed"	
  },
22: {
  "service_type": "Epigenetic Aging : Human DNAge"	
  },
23: {
  "service_type": "Epigenetic Aging : Mouse DNAge"	
  },
24: {
  "service_type": "Epigenetic Aging : Other DNAge"	
  },
25: {
  "service_type": "Gene Expression : Total RNA-Seq"	
  },
26: {
  "service_type": "Gene Expression : microRNA-Seq"	
  },
27: {
  "service_type": "Microbiomics : Other Microbiome"	
  },
28: {
  "service_type": "N/A"	
  },
29: {
  "service_type": "Gene Expression : 3'mRNA-Seq"	
  }
}


function getServiceTypeLookup(serviceTypeArray) {
  let serviceArr = [];
  for (let i=0;i<serviceTypeArray.length;i++) {
    const thisVal = serviceTypeLookup[serviceTypeArray[i]]
      ? serviceTypeLookup[serviceTypeArray[i]]['service_type']
      : "";
    serviceArr.push(thisVal);
  }
  return serviceArr.join(',');
}

function getServiceInquiryInterest() {
  var serviceInterestArr = [];
  var serviceInterestList = "";

  let selectValue = $('#custevent_service_of_interest').val();
  let service_interest = $('input[name=custevent_service_of_interest]') || null;

  if (selectValue) {

    serviceInterestArr = Array.isArray(selectValue) ? selectValue : [selectValue];
    serviceInterestList = getServiceTypeLookup(serviceInterestArr);
    return serviceInterestList;

  } else if (service_interest && service_interest.length) {
    $('input[name=custevent_service_of_interest]').each(function (index) {

      // Handle if it these are checkboxes
      // TODO: Determine if we have a multi select ever on these
      if ($('input[name=custevent_service_of_interest]').is(':checkbox')) {
          if (this.checked) {
            serviceInterestArr.push(this.value);
          }
      }

      if (serviceInterestArr.length) {
        serviceInterestList = getServiceTypeLookup(serviceInterestArr);
      }
    });
  }
  return serviceInterestList;
}
  
const trackServicesInquireForm = (viewOrSubmit) => {

  if ($("input[name=custevent_online_form_name]")) {
    const description = $("input[name=custevent_online_form_name]").val();

    // if description is not defined, just drop off
    if (!description) {
      return false;
    }

    isServicesInquiryForm = true;

    let sample_type = "";

    // temp values to be used to set main one below
    let sample_type1 = "";
    let sample_type2 = "";
    let sample_type3 = "";

    let services_requested = "";
    let eventName = "ServicesInquiryFormView";

    // Specifically specify a services inquiry form is submitted
    if (viewOrSubmit === "submit") {
      eventName = "ServicesInquiryFormSubmission";
    
      // Three types of sample type options are available on these service inquiry forms
      // in some cases two are present, but only one is actually valid
      if ($('#custevent_species_of_interest')) {
        sample_type1 = $('#custevent_species_of_interest').val();
        if (sample_type1 && sample_type1.length > 0) {
          sample_type = sample_type1;
        }
      }

      if ($('#custevent_caseform_sample_types')) {
        sample_type2 = $('#custevent_caseform_sample_types').val();
        if (sample_type2 && sample_type2.length > 0) {
          sample_type = sample_type2;
        }
      }

      if ($('#custom-select-sample-type')) {
        sample_type3 = $('#custom-select-sample-type').val();
        if (sample_type3 && sample_type3.length > 0) {
          sample_type = sample_type3;
        }
      }

      // do the lookup on checkbox, select and multiselect
      services_requested = getServiceInquiryInterest();
    }

    const mixData = {
      description,
      sample_type,
      services_requested,
    }
    mixPanelTrack(eventName, mixData);

  }

}

const trackGoogleFormConversion = () => {

  //track a service inquiry form submit - if conditions are met
  trackServicesInquireForm("submit");

  let trackingDataObj = {};
  let clickTrackDirect = localStorage.getItem("clickTrackGCLIDDirect");
  let clickTrackAssisted = localStorage.getItem("clickTrackGCLIDAssisted");

  let trackingType = "";
  let trackingLandingPage = "";

  trackingDataObj = getClickTrackObject();

  if (clickTrackDirect) {
    trackingType = "direct"
  } else if (clickTrackAssisted) {
    trackingType = "assisted"
  }

  // if the localStorage contains a google ad landing page
  if (trackingDataObj['googleAd'] && trackingDataObj['googleAd']['landingPage'] && trackingDataObj['googleAd']['landingPage'] != "") {
    
    // grab landingPage and gclid from the localStorage object to pass to the mixpanel event.
    trackingLandingPage = trackingDataObj['googleAd']['landingPage'];
    trackingGCLID = trackingDataObj['googleAd']['gclid'];
    
    // if the stored landing page assigned to google ad is the same as the one we're on now....
    if (trackingLandingPage == landingPageUrl) {
      // All things match and are available, then 
      // post data for mix panel, but store in mongo
      postGoogleAdDataToApi("GoogleAdFormSubmission", {
        gclid: trackingGCLID,
        landingPage: landingPageUrl,
        type: trackingType, 
      })
    }

  }

  // Nothing to return, if event fired, it fired otherwise no action taken
  return true;

}

function setCookie(name, value, days) {
  let date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  let expires = "; expires=" + date.toGMTString();
  if (days === 0) {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + ";path=/";
}

function getCookie(cookieName) {
  let cookie = {};
  document.cookie.split(';').forEach(function(el) {
    let [key,value] = el.split('=');
    cookie[key.trim()] = value;
  })
  return cookie[cookieName];
}

function getParam(p) {
  let match = RegExp("[?&]" + p + "=([^&]*)").exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

// TIGHTEN THIS UP

let googleAdDefault = {
  gclid: "",
  landingPage: "",
  campaign: "",
  adGroup: "",
  type: "",
}

let clickTrackObjectGCLID = googleAdDefault;

let utmDefault = {
  source: "",
  medium: "",
  campaign: "",
  content: "",
  term: "",
  landingPage: "",
  type: "",
}

let clickTrackObjectUTM = utmDefault;

/*
This is used to map any non expired cookie values
to output when calling getClickTrackObject()
once 30 days has passed, this function and the related calls in getClickTrackObject()
can be removed, but won't hurt if left in here until we can get this cleaned up.
Can be removed anytime after 6/15/2024
*/


const getClickTrackObject = () => {

  // get all possible stored googleAd objects
  const googleAdDirect = localStorage.getItem('clickTrackGCLIDDirect');
  const googleAdAssisted = localStorage.getItem('clickTrackGCLIDAssisted');

  // get all possible stored utm objects
  const utmDirect = localStorage.getItem('clickTrackUTMDirect');
  const utmAssisted = localStorage.getItem('clickTrackUTMAssisted');

  // test each one in order of priority, ending with the default "blank" object
  const googleAdJson = googleAdDirect || googleAdAssisted || JSON.stringify(googleAdDefault);
  const utmJson = utmDirect || utmAssisted || JSON.stringify(utmDefault);

  const googleAd = JSON.parse(googleAdJson);
  const utm = JSON.parse(utmJson);

  // don't worry about "direct" cookies, as they will only impact 1 day of tracking
  googleAd.type == googleAdDirect ? "direct": "assisted";
  utm.type == utmDirect ? "direct": "assisted";

  let theClickTrackObject = {
    googleAd,
    utm,
    eventTimestamp: new Date().toISOString(),
    orderId: "",
    orderTimestamp: "",
    store: "",
    type: "",
    gat_origin: "",
    customerOrderCount: null,
  }

  // return the most up to date click track object here
  return theClickTrackObject;
}



// only store new data into local storage if some valid values are here
// This will leave existing local storage items in place until expired
let storeGCLIDLocally = false;
let storeUTMLocally = false;

// store gclid and/or utm, if either exists
// if both gclid AND utm are in URL, store them both in localStorage
if (gclid) {

  storeGCLIDLocally = true;

  clickTrackObjectGCLID.gclid = gclid;
  clickTrackObjectGCLID.landingPage = landingPageUrl;
  clickTrackObjectGCLID.eventTimestamp = new Date().toISOString();

  setCookie('allowTrack', true, 2);

  // extract relevant campaign for Netsuite and fire GoogleAdClick in Mix Panel
  trackGoogleClick();
  }
  
  if (utm > -1) {

    storeUTMLocally = true;

    // save only the utm object in LS
    clickTrackObjectUTM.source = getParam("utm_source");
    clickTrackObjectUTM.medium = getParam("utm_medium");
    clickTrackObjectUTM.campaign = getParam("utm_campaign");
    clickTrackObjectUTM.content = getParam("utm_content");
    clickTrackObjectUTM.term = getParam("utm_term");
    clickTrackObjectUTM.landingPage = landingPageUrl;
    clickTrackObjectUTM.eventTimestamp = new Date().toISOString();
  }

  // set dates if storing locally either gclid or utm
  let directDate = new Date();
  let assistedDate = new Date();

  // add days
  directDate.setDate(directDate.getDate() + 1);
  assistedDate.setDate(assistedDate.getDate() + 30);

  // gclid data
  if (storeGCLIDLocally) {
  
    const clickTrackGCLIDDirect = {
      ...clickTrackObjectGCLID,
      type: "direct",
      expires: directDate
    }

    const clickTrackGCLIDAssisted = {
      ...clickTrackObjectGCLID,
      type: "assisted",
      expires: assistedDate
    }  	

    localStorage.setItem("clickTrackGCLIDDirect", JSON.stringify(clickTrackGCLIDDirect));
    localStorage.setItem("clickTrackGCLIDAssisted", JSON.stringify(clickTrackGCLIDAssisted));
}

  // utm data
  if (storeUTMLocally) {
  
      const clickTrackUTMDirect = {
        ...clickTrackObjectUTM,
        type: "direct",
        expires: directDate
      }
  
      const clickTrackUTMAssisted = {
        ...clickTrackObjectUTM,
        type: "assisted",
        expires: assistedDate
      }  	

      localStorage.setItem("clickTrackUTMDirect", JSON.stringify(clickTrackUTMDirect));
      localStorage.setItem("clickTrackUTMAssisted", JSON.stringify(clickTrackUTMAssisted));
  }

// return the object
const checkExpiredClickTrack = (lsItem) => {
  const myLSItem = localStorage.getItem(lsItem);

  if (myLSItem) {
    const myLSItemData = JSON.parse(myLSItem);
    console.log('myLSItemData', myLSItemData);

    // set comparison dates
    const dateNow = new Date();
    const dateExpires = new Date(myLSItemData.expires);

    // We have an old entry, delete it
    if (dateNow >= dateExpires) {
      localStorage.removeItem(lsItem);
    }
  }
}

//track a service inquiry form view - if conditions are met
trackServicesInquireForm("view");

// check any older ones for expiration
checkExpiredClickTrack('clickTrackGCLIDDirect');
checkExpiredClickTrack('clickTrackGCLIDAssisted');
checkExpiredClickTrack('clickTrackUTMDirect');
checkExpiredClickTrack('clickTrackUTMAssisted');

let forceWuFooSubmissionTrack = false;
// WuFoo Form Confirmation Submission Logic
if (window.location.href.indexOf("wufooSubmitted") > -1) {

  // uses embedded wuFoo form, so lp will not match here to place where it was tracked
  if (landingPageUrl.indexOf('/pages/automation') > -1) {
    forceWuFooSubmissionTrack = true;
  }

  setTimeout(function() {
    trackWuFooFormSubmission();
  }, 1200)

  wufooFormSubmissionModal();
}